export function isWechat() {
  if (typeof navigator === 'undefined') return false
  return /MicroMessenger/i.test(navigator.userAgent || '')
}

export function isMobile() {
  if (typeof navigator === 'undefined') return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || '')
}

export function isWxWork() {
  if (typeof navigator === 'undefined') return false
  return /wxwork/i.test(navigator.userAgent || '')
}
